import { withDevToken } from './devSession';

/*
 * The WebSocket server listens on its own port beside the API, so in
 * development (CRA on 3000) sockets go to 8080; in production nginx proxies
 * both from the same host. The dev per-tab token rides along as a query param
 * because browsers can't set headers on a WebSocket.
 */
export const webSocketUrl = (path: string): string => {
  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  return withDevToken(`${protocol}://${window.location.host.replace('3000', '8080')}${path}`);
};
